export const STATUS_TABLE_ACTIVE = 'ACTIVE';
export const STATUS_TABLE_ON_APPROVE = 'ON_APPROVE';
export const STATUS_TABLE_ARCHIVED = 'ARCHIVED';
export const STATUS_TABLE_DECLINED = 'DECLINED';

export const FORMAT_DATE_TABLE = 'DD.MM.YYYY';
